import React, { useReducer } from 'react';
import styles from './SignupLayout.module.css';

const SignupLayout: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles['signup-box']}>{children}</div>
        </div>
    );
};

export default SignupLayout;
